import {
  Box,
  //Button, //Vishy 2025-02-18 build warning not used, so removed
  //Flex, //Vishy 2025-02-18 build warning not used, so removed
  //Image, //Vishy 2025-02-18 build warning not used, so removed
  Link,
  Text,
  //Textarea,//Vishy 2025-02-18 build warning not used, so removed
  VStack,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
//import { Icons } from "../../Assets/icons"; //Vishy 2025-02-18 build warning not used, so removed
//import { CommonAPI } from "../../Apis/commonApi"; //Vishy 2025-02-18 build warning not used, so removed
//import { useToastWrapper } from "../../Wrapper/toastWrapper"; //Vishy 2025-02-18 build warning not used, so removed
//import { errorHandler } from "../../Utils/handler"; //Vishy 2025-02-18 build warning not used, so removed
//import Loader from "../Loader/Loader"; //Vishy 2025-02-18 build warning not used, so removed
import { MdClose } from "react-icons/md";

type Props = {
  handleCloseModal: () => void;
  sellerName?: string;
  docLinks?: { id: string; assetTitle: string; assetUrl: string; assetType?: string }[];
};

// Claude: added assetType subtext; removed star icon 30-03-2026
type LinkItemProps = {
  id: string;
  assetTitle: string;
  assetUrl: string;
  assetType?: string;
};

const LinkItem: React.FC<LinkItemProps> = ({ id, assetTitle, assetUrl, assetType }) => {
  return (
    <Box
      key={id}
      width={"100%"}
      pt={2} pb={2} pl={2} pr={2} mb={2}
      border={"1px"} borderColor={"gray.200"}
    >
      <Link href={assetUrl} textColor={"card.borderBlue"} isExternal fontSize="sm">
        {assetTitle}
      </Link>
      {assetType && (
        <Text fontSize={"10px"} color={"gray.400"} mt={"1px"}>{assetType}</Text>
      )}
    </Box>
  );
};

const ViewDocsModal = (props: Props) => {
  return (
    <Box w={"100%"} h={"100%"} py={"21px"}>
      <VStack
        position={"relative"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        className={"create-meeting-modal"}
      >
        {/* <Text
            fontSize={"20px"}
            fontWeight={700}
            textAlign={"center"}
            color={"black"}
          >
             Create meeting 
          </Text> */}
        {/* <Image
            onClick={() => {
              props.handleCloseModal();
            }}
            position={"absolute"}
            src={Icons.cross}
            right={0}
            top={0}
          /> */}
        <Box
          position={"absolute"}
          right={0}
          top={0}
          pb={3}
          cursor={"pointer"}
          zIndex={200}
        >
          <MdClose
            size={20}
            onClick={() => {
              props.handleCloseModal();
            }}
          />
        </Box>
      </VStack>
      {/* Claude: scrollable doc list 25-03-2026 */}
      <Box
        position={"relative"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
        maxH="60vh"
        overflowY="auto"
      >
        {/* Claude: renamed from "Documents, Images & Videos" 30-03-2026 */}
        <Text
          fontSize={"md"}
          fontWeight={"regular"}
          textAlign={"center"}
          color={"black"}
          mb={"15px"}
        >
          Digital Assets
        </Text>
        <Text
          fontSize={"sm"}
          fontWeight={"medium"}
          textAlign={"center"}
          color={"black"}
          mb={"16px"}
        >
          {props.sellerName}
        </Text>
        {props.docLinks && props.docLinks.length > 0 ? (
          props.docLinks.map((link) => (
            <LinkItem
              id={link.id}
              assetTitle={link.assetTitle}
              assetUrl={link.assetUrl}
              assetType={link.assetType}
            />
          ))
        ) : (
          <Text
            fontSize={"sm"}
            fontWeight={"light"}
            textAlign={"center"}
            color={"black"}
            mb={"16px"}
          >
            No attachments found
          </Text>
        )}
      </Box>
    </Box>
  );
};

export default ViewDocsModal;
